import React from "react";
import styles from "./UsersDetailsGroupsTab.module.css";
import Card from "shared/Card";
import UsersGroupList from "./UsersGroupList";
import SyncStatusKey from "./SyncStatusKey";

const groupList = [
  {
    name: "Albus And Minerva Mcgongall Diamonship",
    groupType: "Diamonship",
    status: "yes",
    pluginType: "None",
    notes: "This is the note..",
  },
  {
    name: "A Non Los Group",
    groupType: "Platinum",
    status: "yes",
    pluginType: "Meta",
    notes: "",
  },
  {
    name: "Albus And Minerva Mcgongall Diamonship",
    groupType: "Diamondship",
    status: "no",
    pluginType: "Group",
    notes: "",
  },
  {
    name: "Albus And Minerva Mcgongall ",
    groupType: "Non LOS",
    status: "important",
    pluginType: "LOS",
    notes: "",
  },
  {
    name: "A Non Los Group",
    groupType: "Platinum",
    status: "important",
    pluginType: "Meta",
    notes: "",
  },
];

/**
 * Content in users details groups page.
 */

export function UsersDetailsGroupsTab() {
  return (
    <>
      <div className={styles.container}>
        <Card className={styles.cardContainer}>
          <div className={styles.cardHeader}>
            <h5 className={styles.title}>GROUPS</h5>
            <div className={styles.hr} />
          </div>

          <div className={styles.usersDiv}>
            <UsersGroupList groups={groupList} />
          </div>
        </Card>

        <SyncStatusKey />
      </div>
    </>
  );
}
